module.exports = __webpack_public_path__ + "static/media/login.386c2897.jpeg";